type DriverLicense = {
  licenseCode?: string | null;
  hasPdp?: boolean | null;
};

type VehicleLicenseRequirement = {
  requiredLicenseCode?: string | null;
  requiresPdp?: boolean | null;
};

const codeRank: Record<string, number> = {
  CODE_8: 8,
  CODE_10: 10,
  CODE_14: 14,
};

const normalizeCode = (code: string) => code.trim().toUpperCase().replace(/\s+/g, "_");

export const canDriverUseVehicle = (
  driver: DriverLicense,
  vehicle: VehicleLicenseRequirement,
) => {
  if (vehicle.requiresPdp === true && driver.hasPdp !== true) return false;

  const requiredCode = vehicle.requiredLicenseCode?.trim();
  if (!requiredCode) return true;

  const driverCode = driver.licenseCode?.trim();
  if (!driverCode) return false;

  const required = normalizeCode(requiredCode);
  const licensed = normalizeCode(driverCode);
  return codeRank[licensed] && codeRank[required]
    ? codeRank[licensed] >= codeRank[required]
    : licensed === required;
};
